module.exports = __webpack_public_path__ + "img/per3.b1106533.png";